// frontend/src/pages/TatmeenHierarchy/TatmeenHierarchy.jsx

import React from "react";
import { Card } from "antd";
import { useSelector } from "react-redux";

import HierarchyForm from "./components/HierarchyForm";
import HierarchyTree from "./components/HierarchyTree";
import SSCCPackingTable from "./components/SSCCPackingTable";

const TatmeenHierarchy = () => {
  // ✅ Get moduleType and selectedReferenceId from Redux
  const { moduleType, selectedReferenceId } = useSelector((state) => state.hierarchy);

  return (
    <Card title="SSCC Hierarchy">
      <HierarchyForm />
      <br />
      <HierarchyTree />
      <br />
      {/* ✅ Only show table when reference is selected */}
      {selectedReferenceId && moduleType && (
        <SSCCPackingTable
          referenceType={moduleType}
          referenceId={selectedReferenceId}
        />
      )}
    </Card>
  );
};

export default TatmeenHierarchy;